.cpxdr55{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:10px;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}.cpxdr55 >p,.cpxdr55 h3,.cpxdr55 .t42049v{margin:0!important;}
